import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const resolutionTypeGuard: CanActivateFn = (route, state) => {

  const allowedTypes: string[] = [
    'accept-tenancy-agreement',
    'appoint-tax-agent',
    'change-tax-agent',
    'appoint-auditor',
    'appoint-director',
    'change-auditor',
    'change-business-address',
    'change-business-nature',
    'change-company-name',
    'change-financial-year',
    'change-registered-address',
    'distribute-dividend',
    'issue-share',
    'others',
    'resign-director',
    'transfer-share',
    'update-director',
    'update-shareholder',
    'ocbc',
    'uob',
    'hlb',
    'open-bank',
    'add-signatory',
    'adoption-of-constitution',
    'purchase-motor-vehicle',
    'sale-and-purchase-agreement',
    'airwallex',
    'director-replacement',
    'other-bank-facility',
    'adoption-common-seal',
    'company-profile-ctc-ssm-form'
  ];
  
  const type = route.paramMap.get('type');
  const router = inject(Router);

  if (type && allowedTypes.includes(type)) {
    return true;
  }

  router.navigate(['/not-found']);
  return false;
};
